"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EthListenerRemoveDialog = exports.removeEthListenerValidationSchema = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_intl_1 = require("react-intl");
const mui_inputs_core_1 = require("@dzambalaorg/mui-inputs-core");
const types_1 = require("@framework/types");
const ui_kit_1 = require("@dzambalaorg/ui-kit");
var validation_1 = require("./validation");
Object.defineProperty(exports, "removeEthListenerValidationSchema", { enumerable: true, get: function () { return validation_1.removeEthListenerValidationSchema; } });
const EthListenerRemoveDialog = () => {
    return ((0, jsx_runtime_1.jsxs)(ui_kit_1.FormGrid, { columns: [1, 3], children: [(0, jsx_runtime_1.jsx)(ui_kit_1.Alert, { severity: "warning", children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "alert.risk" }) }), (0, jsx_runtime_1.jsx)(mui_inputs_core_1.TextInput, { name: "address" }), (0, jsx_runtime_1.jsx)(mui_inputs_core_1.SelectInput, { name: "listenerType", options: types_1.ListenerType }), (0, jsx_runtime_1.jsx)(mui_inputs_core_1.NumberInput, { name: "chainId" })] }));
};
exports.EthListenerRemoveDialog = EthListenerRemoveDialog;
//# sourceMappingURL=index.js.map